<template>
  <div id="app">
    <!-- <iHeader/> -->
    <div class="index-container">
      <div class="ic-banner">
        <div class="w">
          <div class="ic-header">
            <div class="loginImg">
              <img src="../../assets/img/logo.png" alt>
            </div>
            <div class="userBox">
              <el-menu class="docMenu" mode="horizontal">
                <el-submenu index="1">
                  <template slot="title"><span>{{$t("index.documentation")}}</span></template>
                  <el-menu-item index="1-1"><a href="../../static/apidoc/docs.html" target="_blank">API</a></el-menu-item>
                  <el-submenu class="subMenu" index="1-2">
                    <template slot="title">SDK</template>
                    <el-menu-item index="1-2-1"><a href="https://github.com/wanchain/iWan-js-sdk" target="_blank">JavaScript</a></el-menu-item>
                    <el-menu-item index="1-2-2"><a href="https://github.com/wanchain/iWan-java-sdk" target="_blank">Java</a></el-menu-item>
                  </el-submenu>
                </el-submenu>
              </el-menu>
              <i class="line-w"></i>
              <router-link to="login">{{$t("index.login")}}</router-link>
              <i class="line-w"></i>
              <router-link to="register">{{$t("index.signup")}}</router-link>
              <i class="line-w"></i>
              <el-button @click="langToggle">{{$t("index.lang")}}</el-button>
            </div>
          </div>
          <div class="icb-text">
            <h1>{{$t("index.gatewayTitle")}}</h1>
            <i>
              <img src="../../assets/img/line.png" alt>
            </i>
            <h2>{{$t("index.gatewayInfo")}}</h2>
          </div>
          <router-link to="/register" class="freeBtn">{{$t("index.signup")}}</router-link>
          <div class="ico">
            <div>
              <a href="https://t.me/WanchainANN">
                <img src="../../assets/img/tm.png" alt>
              </a>
            </div>
            <div>
              <a href="https://twitter.com/wanchain_org">
                <img src="../../assets/img/f3.png" alt>
              </a>
            </div>
            <div>
              <a href="https://www.facebook.com/wanchainfoundation/">
                <img src="../../assets/img/f5.png" alt>
              </a>
            </div>
            <div>
              <a href="https://github.com/wanchain">
                <img src="../../assets/img/f9.png" alt>
              </a>
            </div>
            <div>
              <a href="mailto:techsupport@wanchain.org">
                <img src="../../assets/img/f11.png" alt>
              </a>
            </div>
            <div>
              <a href="https://weibo.com/wanchain">
                <img src="../../assets/img/web.png" alt>
              </a>
            </div>
            <div class="webcat">
              <a href="javascript:;">
                <img src="../../assets/img/webcat.png" alt>
              </a>
              <img class="weiCode" src="../../assets/img/wechatEn.jpg" alt>
            </div>
            <div class="qq">
              <a href="javascript:;">
                <img src="../../assets/img/qq.png" alt>
              </a>
              <img class="qqCode" src="../../assets/img/qqer.png" alt>
            </div>
          </div>
        </div>
      </div>
      <div class="ic-article">
        <div class="w">
          <h1>{{$t("index.benefitTitle")}}</h1>
          <p class="line-p">
            <i class="com-line2"></i>
          </p>
          <div class="why-container">
            <dl>
              <dt>
                <img src="../../assets/img/wci.png" alt>
              </dt>
              <dd>
                <h5>{{$t("index.benefit1")}}</h5>
                <p>{{$t("index.benefit1info")}}</p>
              </dd>
            </dl>
            <dl>
              <dt>
                <img src="../../assets/img/wci2.png" alt>
              </dt>
              <dd>
                <h5>{{$t("index.benefit2")}}</h5>
                <p>{{$t("index.benefit2info")}}</p>
              </dd>
            </dl>
            <dl>
              <dt>
                <img src="../../assets/img/wci3.png" alt>
              </dt>
              <dd>
                <h5>{{$t("index.benefit3")}}</h5>
                <p>{{$t("index.benefit3info")}}</p>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="he-container">
        <div class="w">
          <h1>{{$t("index.summary")}}</h1>
          <p class="line-p">
            <i class="com-line2"></i>
          </p>
          <ul>
            <li>
              <img class="bit" src="../../assets/img/bit.png" alt>
            </li>
            <li>
              <img class="eth" src="../../assets/img/eth.png" alt>
            </li>
          </ul>
          <!-- <p>State of art reliability and accessibility</p> -->
        </div>
      </div>
    </div>
    <iFooter/>
  </div>
</template>

<script>
import iFooter from "../../components/Footer/Footer";

export default {
  components: {
    // iHeader,
    iFooter
  },
  methods: {
    langToggle() {
      if (this.$i18n.locale == "zh_CN") {
        this.$i18n.locale = "en_US";
      } else {
        this.$i18n.locale = "zh_CN";
      }
      localStorage.setItem("locale", this.$i18n.locale);
    }
  }
};
</script>

<style lang="scss">
.cui{
  color: red;
}
.docMenu {
  > .el-submenu {
    > .el-submenu__title {
      padding: 0px;
    }
    .el-submenu__title:hover {
      border: none;
      background: transparent;
      opacity: 0.7;
    }
    span {
      color: white;
    }
    .el-icon-caret-bottom {
      color: white !important;
      &:before {
        content: "\E600";
      }
    }
  }
  .el-submenu {
    > .el-menu {
      top: 20px;
      left: 0px;
      border: none;
      background-color: rgba(42, 35, 35, .3);
      min-width: 130px;
    }
    .el-submenu__icon-arrow {
      margin-left: 7px;
      margin-top: 4px;
    }
  }
  .subMenu {
    .el-submenu__title {
      padding: 0px 10px;
      line-height: 36px !important;
    }
    > .el-submenu__title {
      font-size: 14px !important;
      display: inline-block;
      width: 100%;
    }
    .el-submenu__icon-arrow {
      position: absolute;
      margin-top: -7px !important;
      right: 10px;
    }
    >.el-menu {
      top: -6px;
      left: 130px !important;
    }
    .el-icon-caret-bottom:before {
      content: "\E602";
    }
  }
  .el-submenu__title {
    color: white;
    border: none !important;
    height: 100% !important;
    line-height: 16px !important;
    font-size: 16px;
    &:hover {
      background: rgba(42, 35, 35, .7);
    }
  }
}
</style>

<style lang="scss" scoped>
.docMenu {
  display: inline-block;
  background: transparent;
  color: white;
  top: 2px;
  .el-submenu {
    text-align: left;
    .el-menu-item {
      text-align: left;
      background-color: transparent;
      min-width: 130px;
      &:hover {
        background-color: rgba(42, 35, 35, .7);
      }
    }
  }
  > .el-submenu {
    > .el-menu a {
      font-size: 14px !important;
      display: inline-block;
      width: 100%;
    }
  }
  .subMenu {
    width: 100%;
    height: 36px;
    line-height: 36px;
    a {
      font-size: 14px !important;
      display: inline-block;
      width: 100%;
    }
  }
}

.index-container {
  width: 100%;
  display: inline-block;
  .ic-banner {
    width: 100%;
    height: 800px;
    color: #fff;
    display: inline-block;
    background: #06102e url("../../assets/img/bg.jpg") no-repeat center;
    background-size: cover;
    .w {
      // width: 1440px;
      width: 70%;
      margin: 0 auto;
      .ic-header {
        width: 100%;
        display: flex;
        margin-bottom: 178px;
        .loginImg {
          margin: 30px 0 0 0;
          flex: 1;
          img {
            width: 110px;
          }
        }
        .userBox {
          margin: 42px 0 0 0;
          flex: 1;
          text-align: right;
          .el-button {
            border: none;
            background: rgba(255, 255, 255, 0) !important;
            color: #fff;
            padding: 10px 0;
          }
          .el-button:hover {
            opacity: 0.7;
            border: none;
            background: rgba(255, 255, 255, 0);
            color: #fff;
          }
          .line-w {
            width: 1.5px;
            height: 15px;
            background: #fff;
            margin: 0 9px;
            display: inline-block;
          }
          a {
            font-size: 16px;
            color: #fff;
          }
          a:hover {
            opacity: 0.7;
          }
        }
      }
      .icb-text {
        width: 677px;
        h1 {
          font-size: 60px;
          font-weight: bold;
          text-transform: uppercase;
          font-family: "RobotoCB";
          font-family: RobotoCB;
        }
        i {
          img {
            margin: 28px 0 30px;
          }
        }
        h2 {
          font-weight: normal;
          font-size: 17px;
          opacity: 0.7;
          margin-bottom: 37px;
        }
      }
      .ico {
        float: left;
        .webcat {
          position: relative;
        }
        .qq {
          position: relative;
        }
        .webcat:hover {
          .weiCode {
            display: inline-block;
          }
        }
        .qq:hover {
          .qqCode {
            display: inline-block;
          }
        }
        .weiCode {
          display: none;
          width: 120px;
          position: absolute;
          top: -123px;
          left: -45px;
        }
        .qqCode {
          display: none;
          width: 120px;
          position: absolute;
          top: -153px;
          left: -40px;
        }
        div {
          float: left;
          margin: 5px 0 0 20px;
          a {
            width: 30px;
            height: 30px;
            margin-right: 15px;
            display: inline-block;
            img {
              width: 100%;
            }
            img:hover {
              opacity: 0.7;
            }
          }
        }
      }
      .freeBtn {
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        float: left;
        color: #fff;
        font-size: 16px;
        border: none;
        font-weight: bold;
        background-image: linear-gradient(90deg, #e6c680 0%, #535046 100%);
        border-radius: 25px;
      }
    }
  }
  .ic-article {
    width: 100%;
    display: inline-block;
    margin: 0 auto;
    padding-bottom: 125px;
    background: #fff;
    .w {
      // width: 1440px;
      width: 70%;
      margin: 0 auto;
      h1 {
        font-size: 24px;
        color: #1e3257;
        margin: 100px auto 0;
        text-align: center;
      }
      .line-p {
        text-align: center;
        margin: 20px 0 28px;
        .com-line2 {
          width: 44px;
          height: 3px;
          display: inline-block;
          background: url("../../assets/img/line2.png") no-repeat center;
        }
      }
      .why-container {
        // width: 1440px;
        width: 100%;
        display: flex;
        margin: 0 auto;
        dl {
          width: 448px;
          height: 400px;
          float: left;
          margin: 0 16px;
          text-align: center;
          background-color: #f8f9fb;
          border-radius: 4px;
          dt {
            height: 148px;
            margin: 55px 0 0;
            display: flex;
            justify-content: center;
            align-items: Center;
          }
          dd {
            h5 {
              font-size: 18px;
              margin: 40px 0 20px;
              text-transform: uppercase;
            }
            p {
              width: 200px;
              margin: 0 auto;
              font-size: 14px;
              color: #626787;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
  .he-container {
    width: 100%;
    height: 400px;
    text-align: center;
    padding-bottom: 60px;
    background: url("../../assets/img/bg2.jpg") no-repeat center;
    background-size: cover;
    .w {
      // width: 1440px;
      width: 92%;
      margin: 0 auto;
      h1 {
        display: inline-block;
        font-size: 24px;
        color: #1e3257;
        margin: 60px auto 0;
        text-align: center;
      }
      .line-p {
        text-align: center;
        margin: 20px 0 8px;
        .com-line2 {
          width: 44px;
          height: 3px;
          display: inline-block;
          background: url("../../assets/img/line2.png") no-repeat center;
        }
      }
      ul {
        // width: 800px;
        margin: 40px 0 auto 0;
        text-align: center;
        text-align: center;
        display: inline-block;
        li {
          // width: 120px;
          height: 108px;
          // background-color: #ffffff;
          // box-shadow: 0px 10px 14px 0px rgba(4, 58, 155, 0.05);
          border-radius: 10px;
          list-style: none;
          float: left;
          margin: 0 40px;
          display: flex;
          justify-content: center;
          align-items: Center;
          .bit {
            width: 300px;
          }
          .eth {
            width: 260px;
          }
        }
      }
      p {
        font-size: 14px;
        color: #626887;
        margin: 50px auto 0;
      }
    }
  }
}
.index {
  width: 100%;
  position: relative;
  img {
    width: 100%;
  }
  .loginBtn {
    width: 200px;
    height: 47px;
    line-height: 47px;
    color: #fff;
    text-align: center;
    font-size: 18px;
    text-decoration: none;
    background-image: linear-gradient(0deg, #1a90fc 0%, #00d2ff 100%);
    border-radius: 30px;
    position: absolute;
    left: 13%;
    top: 20.6%;
  }
}
</style>


// WEBPACK FOOTER //
// Index.vue?0b74cff8